import { nhost } from "@/lib/nhost";
import { generatePKCEPair } from "@nhost/nhost-js/auth";

const LAST_BUY_KEY = "mad_last_buy_page";
const REDIRECT_KEY = "mad_oauth_redirect";
const VERIFIER_KEY = "nhost_pkce_verifier";
export const NEW_GOOGLE_USER_KEY = "mad_google_new_user";

// 🔖 Remember the buying page someone visited (with ?ref=... if any)
export function rememberBuyingPage(pathname: string, search: string) {
  if (pathname !== "/buy" && pathname !== "/purchase") return;
  try {
    sessionStorage.setItem(LAST_BUY_KEY, pathname + search);
  } catch {
    /* ignore */
  }
}

// Only allow pages on OUR site (never send people to another website)
function safeInternalPath(p: string | null | undefined): string | null {
  if (!p) return null;
  if (!p.startsWith("/") || p.startsWith("//")) return null;
  if (p.startsWith("/login") || p.startsWith("/register")) return null;
  return p;
}

// 🧭 Where should someone go after signing in?
export function getPostLoginPath(opts: { isReseller: boolean; redirect?: string | null }): string {
  const asked = safeInternalPath(opts.redirect);
  if (asked) return asked;
  if (opts.isReseller) return "/dashboard";
  let last: string | null = null;
  try {
    last = sessionStorage.getItem(LAST_BUY_KEY);
  } catch {
    last = null;
  }
  return safeInternalPath(last) || "/buy";
}

// 🔑 Start "Continue with Google"
export async function startGoogleSignIn(redirect?: string | null) {
  const { verifier, challenge } = await generatePKCEPair();
  localStorage.setItem(VERIFIER_KEY, verifier);
  if (redirect) sessionStorage.setItem(REDIRECT_KEY, redirect);
  else sessionStorage.removeItem(REDIRECT_KEY);

  const url = nhost.auth.signInProviderURL("google", {
    redirectTo: `${window.location.origin}/login`,
    codeChallenge: challenge,
  });
  window.location.href = url;
}

// Used by the Google "welcome back" handler
export function takeGoogleSignInState(): { verifier: string | null; redirect: string | null } {
  const verifier = localStorage.getItem(VERIFIER_KEY);
  localStorage.removeItem(VERIFIER_KEY);
  const redirect = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return { verifier, redirect };
}